export const styles = {
  display: "table",
  margin: "auto",
};
export const Iconstyle = {
  color: "white",
  position: "absolute",
  top: "8px",
  right: "8px",
  cursor: "pointer",
};

export const IconstyleRed = {
  color: "#c02e26",
  position: "absolute",
  top: "8px",
  right: "8px",
  cursor: "pointer",
};
